<ng-container *ngIf="action$ | async"></ng-container>

<div *ngIf="panel$ | async as panel" class="flex flex-row space-x-3 items-start">
  <csl-item-card
    [iconLink]="getPathToTexture(panel?.material)"
    [disabled]="disabled"
    (selectClicked)="selectMaterial()"
    i18n-title
    title="Материал фасада"
    data-testid="materialItemCard"
    [description]="getMaterialName(panel?.material) || defaultMaterialDescription"
    class="basis-1/2">
    <div
      itemCardIcon
      class="colored-icon"
      *ngIf="!panel?.material?.textureName && panel?.material?.color"
      [ngStyle]="{ 'background-color': '#' + panel?.material?.color }"></div>
  </csl-item-card>

  <ng-container *ngIf="!panel.material?.film; else filmMaterialItemCardBlock">
    <csl-item-card
      class="basis-1/2"
      [iconLink]="getPathToTexture(panel?.l1 || panel?.l2 || panel?.w1 || panel?.w2)"
      [disabled]="disabled"
      (selectClicked)="selectEdgeMaterial()"
      data-testid="materialEdgeItemCard"
      [description]="panel?.l1?.name || panel?.l2?.name || panel?.w1?.name || panel?.w2?.name || defaultEdgeDescription"
      i18n-title
      title="Материал облицовки кромки"
      [class.hidden]="!showEdge">
      <div
        itemCardIcon
        class="colored-icon"
        *ngIf="isColoredEdge(panel)"
        [ngStyle]="{ 'background-color': '#' + getEdgeColor(panel) }"></div>
    </csl-item-card>
  </ng-container>

  <ng-template #filmMaterialItemCardBlock>
    <csl-item-card
      class="basis-1/2"
      [iconLink]="getPathToTexture(panel?.panelOutline?.filmMaterial)"
      [disabled]="disabled"
      (selectClicked)="selectFilmMaterial()"
      [description]="panel?.panelOutline?.filmMaterial?.name || defaultFilmDescription"
      i18n-title
      data-testid="materialFilmItemCard"
      title="Материал пленки"
      [class.hidden]="!showEdge">
      <div
        itemCardIcon
        class="colored-icon"
        *ngIf="!panel?.panelOutline?.filmMaterial?.textureName && panel?.panelOutline?.filmMaterial?.color"
        [ngStyle]="{ 'background-color': '#' + panel?.panelOutline?.filmMaterial?.color }"></div>
    </csl-item-card>
  </ng-template>
</div>
